// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"497":"5d2db5b8","600":"949a90c0"}[chunkId] + ".chunk.js";
};